// Define api end points here
export const AUTH = "/auth";
export const REGISTER = "/register";
export const FORGOT = "/forgot-password";
export const BLOGS = "/blogs";
export const GET_HOHO_FAQS = "/getHohoFaqs";
export const HOHO_FARM = "/hoho-farm";
export const ADD = "/add";
export const NEWS_LETTER = "/news-letter";
export const GET_HOHO_SITE_SETTINGS = "/getHohoSiteSettings";
export const CUSTOMER = "/customer";
export const ORDER_LIST = "/order/list";
export const WISH_LIST = "/wish-list";
export const MY_BOOKINGS_LIST = "/my_bookings/getBookings";
export const REMOVE = "/remove";
export const CATEGORIES = "/categories";
export const URLS = "/urls";
export const BRANDS = "/brands";
export const CAMPAIGN = "/campaign";
export const GET_CAMPAIGN = "/getCampaign";
export const FIND_CAMPAIGN = "/findCampaign";
export const GET_KIGI_SOCIAL_MEDIA = "/getHohoSocialMedia";
export const GALLERY = "/gallery";
export const GET_IMAGES = "/getHohoImages";
export const GET_ABOUT_US = "/hoho-farm/getHohoSiteSettings?type=hoho-about-us";
export const GET_NEWS_LISTS = "/hoho-farm/getHohoSiteSettings?type=hoho-news-list";
export const PRODUCT_DATE = "/product-date";

export const DONATE = "/donate";
export const MAKE_DONATION = "/makeDonation";
export const MEMBERSHIP = "/membership";
export const GET_MEMBERSHIP = "/my_bookings/getMemberships";
// export const GET_MEMBERSHIP = "/getMemberships";
export const EXTRA_CHARGES = "/getMemberships";
export const GET_MEMBERSHIP_BY_QR = "/getMembershipByQr";
export const GET_MEMBERSHIP_BOOKING = "/getMemberships";
export const UPDATE_MEMBERSHIP = "/updateMembership";
export const CANCEL_MEMBERSHIP = "/cancelMembership";
export const UPDATE_FAMILY_MEMBERSHIP = "/updateFamilyMember";

export const GET_LOCATION = "/getFarmLocation";

export const FIND_MEMBERSHIP = "/findMembership";
export const CSA_PRODUCT_PRICE = "/csa-product-price";
export const BOOKMEMBERSHIP = '/bookMembership';

export const PRODUCTS = "/products";
export const DETAILS = "/details";

export const SUBMIT = "/submit";
export const REVIEWS = "/reviews";
export const RATING = "/rating";

export const UPDATE_PROFILE = "/update-profile";
export const ADDRESS = "/address";
export const LIST = "/list";
export const CHANGE_PASSWORD = "/change-password";
export const ORDER = "/order";
export const BLOG_DETAILS = "/blog-details";
export const CONTACT = "/contact";
export const CONTACTUS = "/contactUs";
export const FILTER_TYPES = "/filter_types";
export const MY_DONATION = "/my-donation";
export const FREQUENTLY_BOUGHT = "/frequently-bought";
export const MAKE_DEFAULT = "/make-default";
export const GIFT_CODE = "/gift-code";
export const GET_GIFT_CODE = "/getGiftCode";
export const SITE_SETTINGS = "/getHohoSiteSettings";

export const LOGIN = "/login";
export const RESET_PASSWORD = "/reset-password";
export const STATES = "/states";
export const PROFILE = "/profile"

export const CREATE = "/create";
export const DETAIL = "/detail";
export const STATUS = "/status";


export const PAGES = "/pages";
export const FORM = "/form";
export const DELETE = "/delete";

export const MAKE = "/make";
export const DEFAULT = "/default";
export const NEWSLETTER = "/newsletter";

export const UPDATE = "/update";
export const PAGE = "?page";
export const FAQS = "/faqs";
export const EDIT_ADDRESS = "/edit-address";
export const STORE = "/store";
export const USER = "/user";
export const INFO = "/info";
export const SEARCH = "&search";
export const GET_RATING = "/get-rating";
export const CATEGORY = "/category";
export const GET_CATEGORY = "/get-category";

export const GET_PAGES = "/get-pages";

export const FAQ = "/faq";
export const GET_FAQS = "/get-faqs";
export const GET_BLOG = "/get-blog";
export const BLOG_DETAIL = "/blog-detail";
export const CAREER_APPLICATION = "/career-application";
export const STORE_APPLICATION = "/store-application";

export const MENU = "/menu";
export const GET_MENU = "/get-menu";
export const CATEGORY_ID = "?category_id";
export const GET_MEDIA_FILES = "/get-media-files";

export const MY_ORDERS = "/my-orders";
export const PLACE_ORDER = "/place-order";
export const REMOVE_ALL = "/remove-all";

export const SETTING = "/setting";
export const GET_SETTINGS = "/get-settings";
export const NEWS_LETTER_STORE = "/news-letter-store";
export const POST = "/post";
export const CONFIG = "/config";
export const BUSINESS_SETTINGS = "/business-settings";

export const PAYMENT_METHOD = "/payment-method";
export const SHOW_CARD = "/showCard";

export const REMOVE_CARD = "/removeCard";
export const UPDATE_DEFAULT_CARD = "/updateDefaultCard";
export const GET = "/get";

export const GET_EVENT = "/getEvent";

export const FAVOURITE = "/favourite";
export const LATEST = "/latest";
export const COUPON = "/coupon";
export const APPLY = "/apply";
export const PLACE = "/place";

export const WISHLIST = "/wish-list";

export const EDIT = "/edit";

export const COMPANY_INFORMATION = "/company-information";
export const CUSTOMER_ID = "?customer_id";
export const NAME = "?name";
export const PRICE = "/price";
export const START = "?start";
export const END = "end";
// export const FORGOT_PASSWORD = "/forgot-password";
export const TOP_PRODUCTS = "/top-products";





